import { useHistory } from 'react-router-dom'
import { gtmEvent } from 'lib/gtm'
import { useCoachBookStudentNavigation } from 'lib/pga-coach/use-coach-fast-book-student'

// Adding a booking opens the "Book a student" overlay.
const useAddBookingAction = ({ formLabel }) => {
  const history = useHistory()
  const { navigateToBookStudent } = useCoachBookStudentNavigation()

  return {
    onClick: () => {
      gtmEvent({
        event: 'formSubmit',
        formCategory: 'book-session',
        formAction: 'clicked-book-session-button',
        formLabel,
      })
      navigateToBookStudent(history)
    },
  }
}

export default useAddBookingAction
